<div class="image-answer">
  <app-icon [size]="'24'" [glyph]="'camera'" class="image-answer__camera"></app-icon>
  <app-icon [size]="'20'" [glyph]="'download'"></app-icon>
  <span *ngIf="count" class="image-answer__meta">({{ count }} шт)<ng-container *ngIf="withComment"> + комментарий</ng-container></span>
</div>
